module.exports = __webpack_public_path__ + "static/media/pix.b9c666dd.jpg";